import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./AuthContext";
import Login from "./Login";
import SignUp from "./SignUp";
import Logout from "./Logout";
import StudentRegistration from "./StudentRegistration";
import Dashboard from "./Dashboard";
import Profile from "./Profile";
import MarkSchemes from "./markschemes";
import Chapters from "./Chapters";
import Videos from "./Videos";
import Homeworks from "./Homeworks";
import Exams from "./Exams";
import PastPapers from "./Pastpapers";
import AdminLayout from "./AdminLayout";
import UsersManagement from "./UsersManagement";
import AdminChapters from "./ChaptersManagment";
import AdminVideos from "./AdminVideos";
import AdminMarkSchemes from "./AdminMarkSchemes";
import AdminHomeworks from "./AdminHomeworks";
import AdminPastPapers from "./AdminPastpapers";
import AdminExamGrades from "./AdminExams";
import AdminDashboard from "./AdminDashboard";
import LandingPage from "./LandingPage";
import RegistrationRequests from "./RegistrationRequests";
import AdminHomeworkTracking from "./AdminHomeworkTracking";
import StudentHomeworkStatus from "./StudentHomeworkStatus";
import AdminStudentReport from "./AdminStudentReport";
import AssistantLayout from "./AssistantLayout";
import AssistantDashboard from "./AssistantDashboard";
import AdminMeetings from "./AdminMeetings";
import StudentMeetings from "./StudentMeetings";
import CoursesManagement from "./CoursesManagement";
import AdminAnnouncements from "./AdminAnnouncements";
import Announcements from "./Announcements";
import ExtraQuestions from "./ExtraQuestions";
import AdminExtraQuestions from "./AdminExtraQuestions";
import Layout from "./Layout";
import PDFs from "./PDFs";
import AdminPDFs from "./AdminPDFs";
import AdminStudents from './AdminStudents';
import SuperAdmin from './SuperAdmin';
import AdminAttendance from './AdminAttendance';
import AdminLogin from "./AdminLogin";
import CompleteRegistration from "./CompleteRegistration";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<StudentRegistration />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* Post-login completion route */}
          <Route path="/complete-registration" element={
            <ProtectedRoute allowIncomplete={true}>
              <CompleteRegistration />
            </ProtectedRoute>
          } />

          {/* Student Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute requireEnrolled={true}>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="chapters" element={<Chapters />} />
            <Route path="videos" element={<Videos />} />
            <Route path="markschemes" element={<MarkSchemes />} />
            <Route path="homeworks" element={<Homeworks />} />
            <Route path="exams" element={<Exams />} />
            <Route path="pastpapers" element={<PastPapers />} />
            <Route path="extra-questions" element={<ExtraQuestions />} />
            <Route path="pdfs" element={<PDFs />} />
            <Route path="online-meetings" element={<StudentMeetings />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="profile" element={<Profile />} />
            <Route path="homework_track" element={<StudentHomeworkStatus />} />
          </Route>

          {/* Admin Routes (Restricted) */}
          <Route path="/admin" element={
            <ProtectedRoute requireAdmin={true}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="courses" element={<CoursesManagement />} />
            <Route path="users" element={<UsersManagement />} />
            <Route path="super-admin" element={<SuperAdmin />} />
            <Route path="chapters" element={<AdminChapters />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="markschemes" element={<AdminMarkSchemes />} />
            <Route path="homeworks" element={<AdminHomeworks />} />
            <Route path="pastpapers" element={<AdminPastPapers />} />
            <Route path="exams" element={<AdminExamGrades />} />
            <Route path="registration-requests" element={<RegistrationRequests />} />
            <Route path="hwtracking" element={<AdminHomeworkTracking />} />
            <Route path="studentreport" element={<AdminStudentReport />} />
            <Route path="online-meeting" element={<AdminMeetings />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="extra-questions" element={<AdminExtraQuestions />} />
            <Route path="pdfs" element={<AdminPDFs />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="attendance" element={<AdminAttendance />} />
          </Route>

          {/* Assistant Routes */}
          <Route path="/assistant" element={
            <ProtectedRoute requireAssistant={true}>
              <AssistantLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AssistantDashboard />} />
            <Route path="dashboard" element={<AssistantDashboard />} />
            <Route path="homeworks" element={<AdminHomeworks />} />
            <Route path="exams" element={<AdminExamGrades />} />
            <Route path="hwtracking" element={<AdminHomeworkTracking />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;